export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    enterManagement: 'Enter Management',
    search: 'Search',
    reset: 'Reset',
    loading: 'Loading...',
    noData: 'No Data',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    export: 'Export',
    import: 'Import',
    refresh: 'Refresh',
    filter: 'Filter',
    sort: 'Sort',
    select: 'Select',
    all: 'All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    enabled: 'Enabled',
    disabled: 'Disabled',
    online: 'Online',
    offline: 'Offline',
    active: 'Active',
    inactive: 'Inactive',
    status: 'Status',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    date: 'Date',
    time: 'Time',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    operator: 'Operator',
    remark: 'Remark',
    admin: 'Admin',
    company: 'XXX Company',
    system: 'System',
    currentUser: 'Current User',
    dateRange: 'Date Range',
    batchOperation: 'Batch Operation',
    itemsPerPage: 'Items Per Page',
    goToPage: 'Go to Page',
    lastRefresh: 'Last Refresh',
    actions: 'Actions'
  },

  // Home related
  home: {
    title: 'Home',
    welcome: 'Welcome',
    overview: 'System Overview',
    finishEdit: 'home.finishEdit',
    editHome: 'home.editHome',
    saveLayout: 'home.saveLayout',
    addCard: 'home.addCard',
    editCard: 'home.editCard',
    cardTitle: 'home.cardTitle',
    cardDescription: 'home.cardDescription',
    cardType: 'home.cardType',
    cardColor: 'home.cardColor',
    cardIcon: 'home.cardIcon',
    cardSize: 'home.cardSize'
  },

  navigation: {
    title: 'Navigation',
    dashboard: 'Dashboard',
    dashboardOverview: 'Dashboard Overview',
    dashboardPreview: 'Dashboard Preview',
    dashboardList: 'Dashboard List',
    dashboardDesign: 'Dashboard Design',
    deviceManagement: 'Device Management',
    equipmentManagement: 'Equipment Management',
    monitoring: 'Monitoring',
    applicationManagement: 'Application Management',
    workflow: 'Workflow',
    flow: 'Flow Management',
    dataPlatform: 'Data Management',
    microserviceManagement: 'Microservice Management',
    systemManagement: 'System Management',
    profile: 'Profile',
    notifications: 'Notifications',
    alarm: 'Alarm Management',
    alarmManagement: 'Alarm Management',
    deviceMonitoring: 'Device Monitoring',
    cctv: 'CCTV Monitoring',
    inspectionManagement: 'Inspection Management',
    inspectionReport: 'Inspection Report',
    permissionManagement: 'Permission Management',
    userManagement: 'User Management',
    customDashboard: 'Custom Dashboard',
    ruleEngine: 'Rule Engine',
    home: 'Home',
    apiManagement: 'API Management',
    apiInterface: 'Interface Management',
    apiModel: 'Model Management'
  },
  dashboard: {
    title: 'Dashboard',
    alertSummary: 'Alert Summary',
    todayNewAlert: 'Today New Alerts',
    myTodo: 'My Todo',
    processing: 'Processing',
    myDone: 'My Done',
    inspectionEquipment: 'Inspection Equipment Count',
    unassigned: 'Unassigned',
    totalDevices: 'Total Devices',
    onlineDevices: 'Online Devices',
    offlineDevices: 'Offline Devices',
    alertDevices: 'Alert Devices',
    systemStatus: 'System Status',
    performanceMetrics: 'Performance Metrics',
    recentAlerts: 'Recent Alerts',
    deviceStatus: 'Device Status',
    systemHealth: 'System Health',
    managementTitle: 'Management Title',
    addDashboard: 'Add Dashboard',
    batchSetDefault: 'Batch Set Default',
    preview: 'Preview',
    default: 'Default',
    lastModified: 'Last Modified',
    noDashboards: 'No Dashboards',
    createFirst: 'Create First',
    confirmBatchDelete: 'Confirm Batch Delete',
    editDashboard: 'Edit Dashboard',
    setAsDefault: 'Set As Default',
    fuxaUrl: 'Fuxa Url'
  },
  device: {
    title: 'Device Management',
    description: 'Manage all devices and related functions in the system',
    deviceList: 'Device List',
    deviceListDescription:
      'View and manage basic information, status and configuration of all devices',
    subDevice: 'Sub Device',
    subDeviceManagement: 'Sub Device Management',
    subDeviceDescription: 'Manage sub-devices and related configurations',
    commandManagement: 'Command Management',
    commandManagementDescription:
      'Send device commands, view command history and execution status',
    deviceStatusMonitor: 'Device Status Monitor',
    totalDevices: 'Total Devices',
    pendingCommands: 'Pending Commands',
    addDevice: 'Add Device',
    editDevice: 'Edit Device',
    deviceName: 'Device Name',
    deviceStatus: 'Device Status',
    deviceType: 'Device Type',
    deviceModel: 'Device Model',
    deviceId: 'Device ID',
    nodeId: 'Node ID',
    protocolType: 'Protocol Type',
    mainCircuit: 'Main Circuit',
    subCircuit: 'Sub Circuit',
    commandCount: 'Command Count',
    lastOnlineTime: 'Last Online Time',
    deviceInfo: 'Device Info',
    deviceConfig: 'Device Config',
    deviceCommands: 'Device Commands',
    deviceHistory: 'Device History',
    deviceAlerts: 'Device Alerts',
    deviceMaintenance: 'Device Maintenance',
    deviceLocation: 'Device Location',
    deviceParameters: 'Device Parameters',
    deviceFirmware: 'Device Firmware',
    deviceNetwork: 'Device Network',
    deviceSecurity: 'Device Security',
    deviceStatistics: 'Device Statistics Overview',
    totalDeviceCount: 'Total Device Count',
    onlineDeviceCount: 'Online Device Count',
    offlineDeviceCount: 'Offline Device Count',
    errorDeviceCount: 'Error Device Count',
    deviceAssets: 'Device Assets',
    nameTooLong: 'Name Too Long'
  },
  monitoring: {
    title: 'Monitoring Management',
    realTimeMonitoring: 'Real-time Monitoring',
    alertManagement: 'Alert Management',
    alertHistory: 'Alert History',
    alertRules: 'Alert Rules',
    alertSettings: 'Alert Settings',
    alertLevels: 'Alert Levels',
    alertTypes: 'Alert Types',
    alertStatus: 'Alert Status',
    alertTime: 'Alert Time',
    alertMessage: 'Alert Message',
    alertSource: 'Alert Source',
    alertHandler: 'Alert Handler',
    alertPriority: 'Alert Priority',
    alertCategory: 'Alert Category',
    alertSeverity: 'Alert Severity',
    alertAcknowledged: 'Acknowledged',
    alertUnacknowledged: 'Unacknowledged',
    alertResolved: 'Resolved',
    alertPending: 'Pending',
    alertProcessing: 'Processing'
  },
  workflow: {
    title: 'Workflow Management',
    ruleEngine: 'Rule Engine',
    workflowDesign: 'Workflow Design',
    workflowExecution: 'Workflow Execution',
    workflowHistory: 'Workflow History',
    workflowTemplates: 'Workflow Templates',
    workflowRules: 'Workflow Rules',
    workflowTriggers: 'Workflow Triggers',
    workflowActions: 'Workflow Actions',
    workflowConditions: 'Workflow Conditions',
    workflowVariables: 'Workflow Variables',
    workflowScheduling: 'Workflow Scheduling',
    workflowMonitoring: 'Workflow Monitoring',
    workflowAnalytics: 'Workflow Analytics',
    workflowOptimization: 'Workflow Optimization'
  },
  dataPlatform: {
    title: 'Data Management',
    dashboard: 'Data Overview',
    reports: 'Statistical Reports',
    inspectionReport: 'Inspection Report',
    source: 'Data Source Management',
    tasks: 'Data Tasks'
  },

  application: {
    title: 'Application Management',
    serviceOverview: 'Application Overview',
    fuxaConfig: 'Fuxa Configuration',
    nodeRedConfig: 'Node-RED Configuration'
  },

  equipment: {
    title: 'Equipment Management',
    description: 'Manage all equipment and related functions in the system',
    equipmentList: 'Equipment List',
    equipmentListDescription:
      'View and manage basic information, status and configuration of all equipment',
    addEquipment: 'Add Equipment',
    editEquipment: 'Edit Equipment',
    equipmentDetail: 'Equipment Detail',
    commandManagement: 'Command Management',
    batchEdit: 'Batch Edit',
    importModal: 'Import Module'
  },
  flow: {
    title: 'Flow Management',
    description: 'Manage workflows and scheduling in the system',
    workflowList: 'Workflow List',
    workflowDesign: 'Workflow Design',
    scheduleList: 'Schedule List'
  },

  rolePermission: {
    roleList: 'Role List',
    addRole: 'Add Role',
    editRole: 'Edit Role',
    roleDetail: 'Role Detail',
    roleName: 'Role Name',
    roleDescription: 'Role Description',
    rolePermissions: 'Role Permissions'
  },
  positionManagement: {
    positionList: 'Position List',
    addPosition: 'Add Position',
    editPosition: 'Edit Position',
    positionDetail: 'Position Detail',
    positionName: 'Position Name',
    positionDescription: 'Position Description'
  },
  organizationManagement: {
    organizationList: 'Organization List',
    addOrganization: 'Add Organization',
    editOrganization: 'Edit Organization',
    organizationDetail: 'Organization Detail',
    organizationName: 'Organization Name',
    organizationDescription: 'Organization Description',
    remarks: 'Remarks'
  },

  microservice: {
    pageTitle: 'Microservice Management',
    pageDescription:
      'Manage Docker containers, Kubernetes services and application stacks',
    environment: 'Environment',
    deployStack: 'Deploy Stack',
    searchPlaceholder: 'Search containers/stacks...',
    filterByStatus: 'Filter by Status',
    filterByImage: 'Filter by Image',

    // Container/Stack Properties
    name: 'Name',
    image: 'Image',
    tag: 'Tag',
    statusLabel: 'Status',
    ports: 'Ports',
    cpu: 'CPU',
    memory: 'Memory',
    resources: 'Resource Usage',
    actions: 'Actions',
    standalone: 'Standalone Container',

    // Status
    status: {
      running: 'Running',
      stopped: 'Stopped',
      error: 'Error',
      restarting: 'Restarting'
    },

    // Action Buttons
    start: 'Start',
    stop: 'Stop',
    restart: 'Restart',
    logs: 'Logs',
    monitoring: 'Monitoring',
    edit: 'Edit',
    duplicate: 'Duplicate',
    delete: 'Delete',

    // Deployment Related
    dockerCompose: 'Docker Compose',
    kubernetesYaml: 'Kubernetes YAML',
    uploadFile: 'Upload File',
    composeContent: 'Compose Content',
    composePlaceholder: 'Paste Docker Compose content...',
    yamlContent: 'YAML Content',
    yamlPlaceholder: 'Paste Kubernetes YAML content...',
    selectFile: 'Select File',
    deploy: 'Deploy',
    deploySuccess: 'Deploy Success',
    deploySuccessMessage: 'Stack successfully deployed to selected environment',
    deployError: 'Deploy Error',
    deployErrorMessage:
      'Error occurred during deployment, please check configuration',

    // Logs Related
    containerLogs: 'Container Logs',
    autoRefresh: 'Auto Refresh',
    downloadLogs: 'Download Logs',
    clearLogs: 'Clear Logs',

    // Monitoring Related
    containerMonitoring: 'Container Monitoring',
    cpuUsage: 'CPU Usage',
    memoryUsage: 'Memory Usage',
    networkIO: 'Network I/O',
    diskIO: 'Disk I/O',

    // Confirmation Dialogs
    confirmDelete: 'Confirm Delete',
    deleteWarning:
      'Are you sure you want to delete container "{name}"? This action cannot be undone.',

    // Environment Types
    environmentTypes: {
      docker: 'Docker',
      kubernetes: 'Kubernetes'
    },

    // Container Types
    containerTypes: {
      container: 'Container',
      stack: 'Stack',
      service: 'Service'
    },
    serviceOverview: 'Service Overview',
    fuxaConfig: 'FUXA Config',
    nodeRedConfig: 'Node-RED Config'
  },
  system: {
    title: 'System Management',
    globalManagement: 'Global Management',
    organizationOverview: 'Organization Overview',
    userManagement: 'User Management',
    roleManagement: 'Role Management',
    permissionManagement: 'Permission Management',
    organizationManagement: 'Organization Management',
    positionManagement: 'Position Management',
    systemConfig: 'System Configuration',
    systemLogs: 'System Logs',
    systemBackup: 'System Backup',
    systemRestore: 'System Restore',
    systemUpdate: 'System Update',
    systemMaintenance: 'System Maintenance',
    systemSecurity: 'System Security',
    systemPerformance: 'System Performance',
    systemHealth: 'System Health',
    systemMonitoring: 'System Monitoring',
    rolePermission: 'Role Permission',
    systemSettings: 'System Settings',
    activityLog: 'Activity Log',
    serviceLogs: 'Service Logs',
    loginHistory: 'Login History',
    configService: 'Configuration Service',
    monitoringAndLogs: 'Monitoring and Logs'
  },

  deviceMonitoring: {
    title: 'Device Monitoring',
    description:
      'Real-time monitoring of device status and performance metrics',
    deviceStatus: 'Device Status',
    realTimeMetrics: 'Real-time Metrics',
    monitorProperties: 'Monitor Properties',
    deviceStatusDescription:
      'View real-time status and basic information of all devices',
    realTimeMetricsDescription:
      'Monitor real-time performance metrics and data of devices',
    monitorPropertiesDescription:
      'Configure monitoring properties and alert rules'
  },

  user: {
    title: 'User Management',
    username: 'Username',
    password: 'Password',
    email: 'Email',
    phone: 'Phone',
    fullName: 'Full Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    department: 'Department',
    position: 'Position',
    role: 'Role',
    permissions: 'Permissions',
    lastLogin: 'Last Login',
    loginTime: 'Login Time',
    logoutTime: 'Logout Time',
    loginIp: 'Login IP',
    userProfile: 'User Profile',
    userSettings: 'User Settings',
    userPreferences: 'User Preferences',
    userActivity: 'User Activity',
    userSessions: 'User Sessions',
    systemAdmin: 'System Administrator',
    maintenanceEngineer: 'Maintenance Engineer',
    monitor: 'Monitor'
  },

  userManagement: {
    userName: 'User Name',
    loginAccount: 'Login Account',
    organization: 'Organization',
    organizationType: 'Organization Type',
    position: 'Position',
    role: 'Role',
    freezeUser: 'Freeze User',
    unfreezeUser: 'Unfreeze User',
    resetPassword: 'Reset Password',
    userList: 'User List',
    userManagement: 'User Management',
    accountManagement: 'Account Management',
    organizationManagement: 'Organization Management',
    rolePermissions: 'Role Permissions',
    active: 'Active',
    inactive: 'Inactive',
    suspended: 'Suspended',
    accountStatus: 'Account Status',
    addUser: 'Add User'
  },
  role: {
    title: 'Role Management',
    roleName: 'Role Name',
    roleDescription: 'Role Description',
    rolePermissions: 'Role Permissions',
    roleUsers: 'Role Users',
    roleType: 'Role Type',
    roleLevel: 'Role Level',
    roleStatus: 'Role Status',
    roleCreation: 'Role Creation',
    roleModification: 'Role Modification',
    roleDeletion: 'Role Deletion',
    roleAssignment: 'Role Assignment',
    roleRevocation: 'Role Revocation',
    roleInheritance: 'Role Inheritance',
    roleHierarchy: 'Role Hierarchy'
  },
  organization: {
    title: 'Organization Management',
    organizationName: 'Organization Name',
    organizationCode: 'Organization Code',
    organizationType: 'Organization Type',
    organizationLevel: 'Organization Level',
    organizationParent: 'Parent Organization',
    organizationChildren: 'Child Organizations',
    organizationLeader: 'Organization Leader',
    organizationContact: 'Organization Contact',
    organizationAddress: 'Organization Address',
    organizationPhone: 'Organization Phone',
    organizationEmail: 'Organization Email',
    organizationWebsite: 'Organization Website',
    organizationDescription: 'Organization Description',
    organizationStatus: 'Organization Status',
    organizationCreation: 'Organization Creation',
    organizationModification: 'Organization Modification'
  },
  inspection: {
    title: 'Inspection Management',
    inspectionSchedule: 'Inspection Schedule',
    inspectionRoute: 'Inspection Route',
    inspectionReport: 'Inspection Report',
    inspectionTask: 'Inspection Task',
    inspectionResult: 'Inspection Result',
    inspectionStatus: 'Inspection Status',
    inspectionType: 'Inspection Type',
    inspectionFrequency: 'Inspection Frequency',
    inspectionDuration: 'Inspection Duration',
    inspectionArea: 'Inspection Area',
    inspectionEquipment: 'Inspection Equipment',
    inspectionInspector: 'Inspection Inspector',
    inspectionDate: 'Inspection Date',
    inspectionTime: 'Inspection Time',
    inspectionNotes: 'Inspection Notes',
    inspectionPhotos: 'Inspection Photos',
    inspectionVideos: 'Inspection Videos',
    inspectionAlerts: 'Inspection Alerts',
    inspectionMaintenance: 'Inspection Maintenance'
  },

  inspectionSchedule: {
    title: 'Inspection Schedule',
    routePlanning: 'Route Planning',
    addSchedule: 'Add Schedule',
    editSchedule: 'Edit Schedule',
    scheduleId: 'Schedule ID',
    time: 'Time',
    inspector: 'Inspector',
    scheduler: 'Scheduler',
    licensePlateNumber: 'License Plate Number',
    task: 'Task',
    inspectionRoute: 'Inspection Route',
    actions: 'Actions',
    year: 'Year',
    month: 'Month',
    sunday: 'Sun',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat'
  },
  notification: {
    title: 'Notification Management',
    notificationCenter: 'Notification Center',
    notificationSettings: 'Notification Settings',
    notificationHistory: 'Notification History',
    notificationTypes: 'Notification Types',
    notificationChannels: 'Notification Channels',
    notificationTemplates: 'Notification Templates',
    notificationRules: 'Notification Rules',
    notificationScheduling: 'Notification Scheduling',
    notificationDelivery: 'Notification Delivery',
    notificationStatus: 'Notification Status',
    notificationPriority: 'Notification Priority',
    notificationRead: 'Read',
    notificationUnread: 'Unread',
    notificationSent: 'Sent',
    notificationFailed: 'Failed',
    notificationPending: 'Pending',
    notificationProcessing: 'Processing',
    assignedToYou: 'assigned a work order to you'
  },

  notificationCenter: {
    title: 'Notification Center',
    description: 'Manage all notification messages in the system',
    totalNotifications: 'Total Notifications',
    readNotifications: 'Read Notifications',
    unreadNotifications: 'Unread Notifications',
    urgentNotifications: 'Urgent Notifications',
    addNotification: 'Add Notification',
    markAllAsRead: 'Mark All as Read',
    deleteReadNotifications: 'Delete Read Notifications',
    status: 'Status',
    priority: 'Priority',
    keywordSearch: 'Keyword Search',
    filter: 'Filter',
    notificationDetail: 'Notification Detail',
    notificationTitle: 'Title',
    content: 'Content',
    targetUsers: 'Target Users',
    createdAt: 'Created At',
    actions: 'Actions',
    editNotification: 'Edit Notification',
    cancel: 'Cancel',
    update: 'Update',
    add: 'Add',
    close: 'Close',
    titleRequired: 'Title is required',
    contentRequired: 'Content is required',
    read: 'Read',
    unread: 'Unread',
    low: 'Low',
    normal: 'Normal',
    high: 'High',
    urgent: 'Urgent'
  },
  profile: {
    title: 'Profile Management',
    personalProfile: 'Personal Profile',
    personalInfo: 'Personal Information',
    profileDescription: 'Other users can identify you through company and name',
    userName: 'User Name',
    loginAccount: 'Login Account',
    organization: 'Organization',
    organizationType: 'Organization Type',
    department: 'Department',
    position: 'Position',
    role: 'Role',
    gender: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    birthday: 'Birthday',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    changePassword: 'Change Password',
    passwordMismatch: 'New password and confirm password do not match',
    interfaceLanguage: 'Interface Language',
    systemTimezone: 'System Timezone',
    traditionalChinese: 'Traditional Chinese',
    english: 'English',
    preferences: 'Preferences',
    savePreferences: 'Save Preferences',
    resetPassword: 'Reset Password',
    accountSettings: 'Account Settings',
    securitySettings: 'Security Settings',
    notificationPreferences: 'Notification Preferences',
    languageSettings: 'Language Settings',
    themeSettings: 'Theme Settings',
    privacySettings: 'Privacy Settings',
    passwordChange: 'Password Change',
    emailVerification: 'Email Verification',
    phoneVerification: 'Phone Verification',
    twoFactorAuth: 'Two-Factor Authentication',
    loginHistory: 'Login History',
    activityLog: 'Activity Log',
    dataExport: 'Data Export',
    accountDeletion: 'Account Deletion'
  },
  auth: {
    title: 'Authentication',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    changePassword: 'Change Password',
    verifyEmail: 'Verify Email',
    verifyPhone: 'Verify Phone',
    twoFactorSetup: 'Two-Factor Setup',
    rememberMe: 'Remember Me',
    staySignedIn: 'Stay Signed In',
    signInWith: 'Sign in with',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account',
    dontHaveAccount: "Don't have an account",
    loginSuccess: 'Login Success',
    loginFailed: 'Login Failed',
    logoutSuccess: 'Logout Success',
    sessionExpired: 'Session Expired',
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden'
  },
  error: {
    title: 'Error',
    pageNotFound: 'Page Not Found',
    serverError: 'Server Error',
    networkError: 'Network Error',
    timeoutError: 'Timeout Error',
    validationError: 'Validation Error',
    permissionError: 'Permission Error',
    authenticationError: 'Authentication Error',
    authorizationError: 'Authorization Error',
    resourceNotFound: 'Resource Not Found',
    serviceUnavailable: 'Service Unavailable',
    badRequest: 'Bad Request',
    forbidden: 'Forbidden',
    internalServerError: 'Internal Server Error',
    gatewayTimeout: 'Gateway Timeout',
    tooManyRequests: 'Too Many Requests'
  },
  time: {
    now: 'Now',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    nextWeek: 'Next Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    nextMonth: 'Next Month',
    thisYear: 'This Year',
    lastYear: 'Last Year',
    nextYear: 'Next Year',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    night: 'Night',
    seconds: 'Seconds',
    minutes: 'Minutes',
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',
    years: 'Years'
  },
  i18n: {
    title: 'Internationalization Test',
    description: 'This is a page for testing internationalization features',
    welcome: 'Welcome to internationalization features',
    language: 'Language',
    currentLanguage: 'Current Language',
    changeLanguage: 'Change Language',
    languageSettings: 'Language Settings',
    languageSwitcher: 'Language Switcher',
    languageCode: 'Language Code',
    languageName: 'Language Name',
    currentTime: 'Current Time'
  },
  alarm: {
    title: 'Alarm Management',
    alarmHistory: 'Alarm History',
    alarmRules: 'Alarm Rules',
    alarmSettings: 'Alarm Settings',
    alarmLevels: 'Alarm Levels',
    alarmTypes: 'Alarm Types',
    alarmStatus: 'Alarm Status',
    alarmTime: 'Alarm Time',
    alarmMessage: 'Alarm Message',
    alarmSource: 'Alarm Source',
    alarmHandler: 'Alarm Handler',
    alarmPriority: 'Alarm Priority',
    alarmCategory: 'Alarm Category',
    alarmSeverity: 'Alarm Severity',
    alarmAcknowledged: 'Acknowledged',
    alarmUnacknowledged: 'Unacknowledged',
    alarmResolved: 'Resolved',
    alarmPending: 'Pending',
    alarmProcessing: 'Processing',
    alarmStatistics: 'Alarm Statistics',
    alarmTrends: 'Alarm Trends',
    alarmReports: 'Alarm Reports',
    alarmNotifications: 'Alarm Notifications',
    alarmEscalation: 'Alarm Escalation',
    alarmSuppression: 'Alarm Suppression',
    alarmCorrelation: 'Alarm Correlation',
    alarmForecasting: 'Alarm Forecasting',
    alarmOptimization: 'Alarm Optimization'
  },

  alarmMessages: {
    title: 'Alarm Messages',
    description: 'Manage all alarm messages in the system',
    totalAlarms: 'Total Alarms',
    unprocessed: 'Unprocessed',
    processing: 'Processing',
    processed: 'Processed',
    refresh: 'Refresh',
    batchProcess: 'Batch Process',
    exportReport: 'Export Report',
    clearProcessed: 'Clear Processed',
    status: 'Status',
    priority: 'Priority',
    deviceType: 'Device Type',
    keywordSearch: 'Keyword Search',
    filter: 'Filter',
    alarmDetail: 'Alarm Detail',
    deviceSn: 'Device SN',
    alarmNumber: 'Alarm Number',
    deviceLocation: 'Device Location',
    alarmValue: 'Alarm Value',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    alarmDescription: 'Alarm Description',
    processNote: 'Process Note',
    unknown: 'Unknown',
    noDescription: 'No Description',
    startProcess: 'Start Process',
    completeProcess: 'Complete Process',
    close: 'Close',
    batchProcessAlarm: 'Batch Process Alarm',
    selectAction: 'Select Action',
    cancel: 'Cancel',
    confirm: 'Confirm',
    low: 'Low',
    normal: 'Normal',
    high: 'High',
    critical: 'Critical',
    camera: 'Camera',
    accessControl: 'Access Control',
    sensor: 'Sensor',
    controller: 'Controller',
    batchMarkProcessing: 'Batch Mark as Processing',
    batchMarkProcessed: 'Batch Mark as Processed',
    batchDelete: 'Batch Delete',
    actions: 'Actions'
  },

  integratedMonitoring: {
    title: 'Integrated Monitoring Center',
    description:
      'One-stop monitoring management platform - comprehensive monitoring of device status, environmental parameters, and security alerts',
    totalDevices: 'Total Devices',
    onlineDevices: 'Online Devices',
    activeAlarms: 'Active Alarms',
    todayAlarms: 'Today Alarms',
    unreadNotifications: 'Unread Notifications',
    systemHealth: 'System Health',
    realtimeAlarms: 'Real-time Alarms',
    viewAll: 'View All',
    noAlarms: 'No Alarms',
    deviceStatusDistribution: 'Device Status Distribution',
    environmentMonitoring: 'Environment Monitoring',
    devicePerformanceTrend: 'Device Performance Trend',
    alarmTrendStatistics: 'Alarm Trend Statistics',
    monitoringDataStorage: 'Monitoring Data Storage Management',
    threeModuleIntegration: 'Three Module Integration Management',
    monitoringManagement: 'Monitoring Management'
  },

  cctv: {
    server: 'Server',
    user: 'User',
    clearSettings: 'Clear Settings',
    enterModifyUrl: 'Please Enter Modify URL',
    cancel: 'Cancel',
    save: 'Save'
  },

  customDashboard: {
    editorNotConfigured: 'Custom Dashboard Editor Not Configured',
    serviceNotConfigured: 'Custom Dashboard Service Not Configured',
    checkEnvironmentVariable:
      'Please check if environment variable VITE_FUXA_HOST is set'
  },

  inspectionReport: {
    title: 'Inspection Report',
    reported: 'Reported',
    notReported: 'Not Reported',
    inspectionId: 'Inspection ID',
    scheduledTime: 'Scheduled Time',
    actualTime: 'Actual Time',
    inspectionPoint: 'Inspection Point',
    taskContent: 'Task Content',
    inspectionPersonnel: 'Inspection Personnel',
    status: 'Status',
    reportContent: 'Report Content',
    attachments: 'Attachments',
    actions: 'Actions',
    abnormalId: 'Abnormal ID',
    abnormalType: 'Abnormal Type',
    abnormalContent: 'Abnormal Content',
    discoveryLocation: 'Discovery Location',
    discoveredBy: 'Discovered By',
    assignedPersonnel: 'Assigned Personnel',
    discoveryTime: 'Discovery Time',
    completionTime: 'Completion Time'
  },
  deviceStatus: {
    title: 'Device Status',
    description: 'Monitor and manage the status of all devices',
    totalDevices: 'Total Devices',
    onlineDevices: 'Online Devices',
    offlineDevices: 'Offline Devices',
    abnormalDevices: 'Abnormal Devices',
    statusDistribution: 'Status Distribution',
    deviceTypeStats: 'Device Type Statistics',
    refreshStatus: 'Refresh Status',
    exportReport: 'Export Report',
    batchActions: 'Batch Actions',
    status: 'Status',
    deviceType: 'Device Type',
    location: 'Location',
    deviceNameSn: 'Device Name/SN',
    applyFilters: 'Apply Filters',
    deviceDetail: 'Device Detail',
    deviceName: 'Device Name',
    deviceSn: 'Device SN',
    ipAddress: 'IP Address',
    firstOnlineTime: 'First Online Time',
    lastOnlineTime: 'Last Online Time',
    deviceDescription: 'Device Description',
    noDescription: 'No Description',
    close: 'Close',
    chooseAction: 'Choose Action',
    newLocation: 'New Location',
    cancel: 'Cancel',
    confirm: 'Confirm',
    actions: 'Actions',
    online: 'Online',
    offline: 'Offline',
    abnormal: 'Abnormal',
    camera: 'Camera',
    accessControl: 'Access Control',
    sensor: 'Sensor',
    controller: 'Controller',
    floor1Lobby: '1F Lobby',
    floor2Office: '2F Office',
    parking: 'Parking',
    serverRoom: 'Server Room',
    restart: 'Restart',
    updateLocation: 'Update Location',
    syncTime: 'Sync Time'
  },
  apiManagement: {
    apiInterface: 'Interface Management',
    apiModel: 'Model Management',
    addApi: 'Add API',
    addModel: 'Add Model',
    generateLib: 'Generate Library File',
    searchInterfaceId: 'Enter Interface ID',
    searchInterfacePath: 'Enter Interface Path',
    searchModule: 'Enter Module ID',
    module: 'Module ID',
    interfaceId: 'Interface ID',
    url: 'URL',
    method: 'Method',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    action: 'Action',
    collectorLabel: 'Collector',
    selectCollector: 'Select Collector',
    gatewayUid: 'Gateway UID',
    selectGateway: 'Select Gateway',
    moduleDesc: 'Module Description',
    selectModule: 'Select Module',
    interfaceIds: 'Interface IDs',
    interfaceIdsPlaceholder: 'Multiple interface IDs separated by comma',
    interval: 'Interval',
    collectorA: 'Collector A',
    collectorB: 'Collector B',
    gatewayA: 'Gateway A',
    gatewayB: 'Gateway B',
    moduleA: 'Module A',
    moduleB: 'Module B',
    temperatureSensor: 'Temperature Sensor',
    pressureSensor: 'Pressure Sensor'
  },
  search: {
    placeholder: 'Search features, pages, or settings...',
    searching: 'Searching...',
    noResults: 'No results found',
    noResultsDesc:
      'Try using different keywords, or check the popular features below',
    popularFeatures: 'Popular Features',
    searchTips: 'Search Tips',
    tip1: 'Search by feature name, such as "Device Management" or "Alarms"',
    tip2: 'Use Ctrl+K (Windows) or Cmd+K (Mac) to quickly open search',
    tip3: 'Search results are automatically sorted by relevance',
    // 新增的 sitemap 相關 key
    frequentlyUsed: 'Frequently Used',
    fullSitemap: 'Full Sitemap',
    categoryHome: 'Home',
    categoryDashboard: 'Dashboard',
    categoryDevicemanagement: 'Device Management',
    categoryMonitoring: 'Device Monitoring',
    categoryEquipment: 'Equipment Management',
    categoryFlow: 'Workflow Management',
    categoryWorkflow: 'Workflow Management',
    categoryDataplatform: 'Data Management',
    categoryData: 'Data Management',
    categoryMicroservicemanagement: 'Microservice Management',
    categoryApimanagement: 'API Management',
    categoryInspectionmanagement: 'Inspection Management',
    categoryNotificationmanagement: 'Notification Management',
    categorySystemmanagement: 'System Management',
    categorySystem: 'System Management',
    // 搜索结果描述
    dashboardDesc: 'View and manage dashboards',
    dashboardListDesc: 'Browse all dashboard lists',
    dashboardDesignDesc: 'Design and edit custom dashboards',
    deviceMonitoringDesc: 'Monitor device status and performance',
    deviceStatusDesc: 'View device real-time status',
    realTimeMetricsDesc: 'View real-time data metrics',
    equipmentManagementDesc: 'Manage devices and assets',
    deviceListDesc: 'View device list',
    flowDesc: 'Manage workflows and rules',
    workflowListDesc: 'View workflow list',
    dataPlatformDesc: 'Data platform and visualization',
    microserviceDesc: 'Manage microservice configuration',
    apiManagementDesc: 'Manage API interfaces and models',
    alarmDesc: 'Handle alarm events',
    inspectionReportDesc: 'View inspection reports',
    systemManagementDesc: 'System settings and management',
    // 新增缺失的翻譯鍵值
    homeDesc: 'System home and overview',
    monitoringDesc: 'Device monitoring and management',
    devicemanagementDesc: 'Device management and configuration',
    dataplatformDesc: 'Data platform and visualization',
    microservicemanagementDesc: 'Microservice management and configuration',
    apimanagementDesc: 'API interface management',
    inspectionmanagementDesc: 'Inspection report management',
    notificationmanagementDesc: 'Notification system management',
    systemmanagementDesc: 'System settings',
    // 子項目描述
    navigationdashboardListDesc: 'Browse all dashboard lists',
    navigationdashboardDesignDesc: 'Design and edit custom dashboards',
    navigationdashboardPreviewDesc: 'Preview dashboard effects',
    deviceMonitoringdeviceStatusDesc: 'View device real-time status',
    deviceMonitoringrealTimeMetricsDesc: 'View real-time data metrics',
    deviceMonitoringmonitorPropertiesDesc: 'Monitor device properties',
    devicedeviceListDesc: 'View device list',
    devicesubDeviceManagementDesc: 'Manage sub-devices',
    devicecommandManagementDesc: 'Device command management',
    flowworkflowListDesc: 'View workflow list',
    flowworkflowDesignDesc: 'Design workflows',
    flowscheduleListDesc: 'View schedule list',
    dataPlatformdataPlatformMapDesc: 'Data platform map',
    dataPlatformdataPlatformMapboxDesc: 'Data platform Mapbox',
    dataPlatformdataPlatformLineChartDesc: 'Data platform line chart',
    dataPlatformdataPlatformPieChartDesc: 'Data platform pie chart',
    microserviceserviceOverviewDesc: 'Service overview',
    microservicefuxaConfigDesc: 'Fuxa configuration',
    microservicenodeRedConfigDesc: 'Node-RED configuration',
    apiManagementapiInterfaceDesc: 'API interface management',
    apiManagementapiModelDesc: 'API model management',
    alarmalarmListDesc: 'Alarm list',
    inspectionReportreportListDesc: 'Inspection report list',
    notificationnotificationCenterDesc: 'Notification center',
    notificationnotificationSettingsDesc: 'Notification settings',
    notificationnotificationHistoryDesc: 'Notification history',
    systemglobalManagementDesc: 'Global management',
    systemconfigServiceDesc: 'Configuration service',
    systemmonitoringAndLogsDesc: 'Monitoring and logs',
    userManagementuserListDesc: 'User management',
    rolePermissionroleListDesc: 'Role permission management',
    positionManagementpositionListDesc: 'Position management',
    organizationManagementorganizationListDesc: 'Organization management',
    systemsystemSettingsDesc: 'System settings',
    // 其他可能遺漏的翻譯鍵值
    navigationhomeDesc: 'System home',
    navigationdashboardDesc: 'Dashboard management',
    navigationdeviceMonitoringDesc: 'Device monitoring',
    navigationequipmentManagementDesc: 'Equipment management',
    navigationflowDesc: 'Workflow management',
    navigationdataPlatformDesc: 'Data platform',
    navigationmicroserviceManagementDesc: 'Microservice management',
    navigationapiManagementDesc: 'API management',
    navigationalarmDesc: 'Alarm management',
    navigationinspectionReportDesc: 'Inspection report',
    navigationnotificationsDesc: 'Notification management',
    navigationsystemManagementDesc: 'System management',
    deviceDesc: 'Device management',
    userManagementDesc: 'User management',
    rolePermissionDesc: 'Role permissions',
    positionManagementDesc: 'Position management',
    organizationManagementDesc: 'Organization management'
  },

  sidebar: {
    expandAll: 'Expand All',
    collapseAll: 'Collapse All'
  },

  footer: {
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy'
  }
};
